import { useState, useEffect } from "react";
import Input from "../../../../ui/Input/Input";
import "./Open.css";

function Open({ question, onUpdateAnswer, invalidKeys }) {
  const [answer, setAnswer] = useState("");
  const isInvalid = invalidKeys.includes(question.key);

  useEffect(() => {
    if (question.optional) {
      const answer = {
        key: question.key,
        answer: "",
        question: question.description,
        type: question.answersType,
        optional: question.optional,
      };
      onUpdateAnswer(answer);
    }
  }, [question]);

  function updateAnswerHandler(e) {
    let enteredValue = e.target.value;
    if (question.toUpper) enteredValue = enteredValue.toUpperCase();
    setAnswer(enteredValue);
    const answer = {
      key: question.key,
      answer: enteredValue,
      question: question.description,
      type: question.answersType,
      optional: question.optional,
    };
    onUpdateAnswer(answer);
  }

  return (
    <div className={isInvalid ? "error" : "mainOpen"}>
      <Input
        label={question.description}
        onUpdateValue={updateAnswerHandler.bind(this)}
        value={question.forcedValue ? question.forcedValue : answer}
        maxLength={question.maxLength}
        multiline={question.multiline}
        autoCompleteType="off"
        isEditable={!question.forcedValue}
      />
    </div>
  );
}

export default Open;
